"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  fill: "red",
  d: "M23.495 6.205a3.02 3.02 0 0 0-2.067-2.083l-.021-.005c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.02 3.02 0 0 0 .532 6.184l-.005.021C.195 7.916.005 9.882.005 11.894v.122-.006.095c0 2.011.19 3.978.553 5.884l-.031-.195a3.02 3.02 0 0 0 2.067 2.083l.021.005c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.02 3.02 0 0 0 2.083-2.067l.005-.021c.319-1.675.501-3.602.501-5.572l-.001-.223v.011l.001-.232c0-1.969-.182-3.897-.531-5.765l.03.193zM9.609 15.601V8.408l6.264 3.602z"
}), 'Youtube');
